import { render } from "./PreserveAspectRatioInput.vue?vue&type=template&id=6bc49788&scoped=true&ts=true"
import script from "./PreserveAspectRatioInput.vue?vue&type=script&lang=ts"
export * from "./PreserveAspectRatioInput.vue?vue&type=script&lang=ts"

import "./PreserveAspectRatioInput.vue?vue&type=style&index=0&id=6bc49788&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc49788"]])

export default __exports__